const creditCardManagement = {
    $body: undefined,
    init() {
        this.$body = $('body');
        this.bindEvents();
        this.bindToolTips();
    },
    tooltipTemplate(title, confirm, cancel, paymentId) {
        return `<div class="mb-2">${title}</div>
            <div class="tooltip-buttons">
                <button type="button" class="js-tooltip-cancel btn btn-secondary btn-inverse btn-sm">${cancel}</button>
                &nbsp;
                <a href="${paymentId}" class="btn btn-primary btn-inverse btn-sm">${confirm}</a>
            </div>`;
    },
    bindEvents() {
        this.$body.on('click', '.js-request-delete-card', (evt) => {
            evt.preventDefault();
            $(evt.currentTarget).tooltip('show');
        });
        this.$body.on('click', '.js-tooltip-cancel', (evt) => {
            evt.preventDefault();
            $(evt.currentTarget).closest('.tooltip').tooltip('hide');
        });
    },
    bindToolTips() {
        const $deleteCard = $('.js-request-delete-card');

        $deleteCard.each(function (i, deleteIcon) {
            const $deleteIcon = $(deleteIcon);

            $deleteIcon.tooltip({
                html:      true,
                sanitize:  false,
                container: '.payment__header',
                title:     creditCardManagement.tooltipTemplate(
                        $deleteIcon.data('tooltip-title'),
                        $deleteIcon.data('tooltip-confirm'),
                        $deleteIcon.data('tooltip-cancel'),
                        $deleteIcon.data('url')
                ),
                placement: 'top',
                trigger:   'manual'
            });
        })

    },
};

$(() => {
    if ($('#creditcard-page')) {
        creditCardManagement.init();
    }
});
export default creditCardManagement;
